export default __webpack_public_path__ + "static/equipe-etcheverry-mindurry-4aee04c2c652cc73a9ac2251b56d0310.jpg";